import { render, staticRenderFns } from "./areaAmount.vue?vue&type=template&id=4f782f48&scoped=true&"
import script from "./areaAmount.vue?vue&type=script&lang=js&"
export * from "./areaAmount.vue?vue&type=script&lang=js&"
import style0 from "./areaAmount.vue?vue&type=style&index=0&id=4f782f48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f782f48",
  null
  
)

export default component.exports